import Homepage from "./Page/Homepage";
import OpenDialog from "./Component/Opendialog";
import Circular from "./Component/Circular";

function App() {
  return <Homepage />;
}
export default App;
